<template>
    <div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div id="handoversTodos" class="todo-category accordion-item">
                <div class="accordion-header-container">
                    <div class="accordion-header">
                        <button class="accordion-button collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#handoversTodo"
                                aria-expanded="false" aria-controls="handoversTodo">
                                <span class="round-icon bg-tangerine text-white me-3">
                                    <i class="fa fa-building"></i>
                                </span>

                            <span class="fw-semibold">Opleverpunten</span>
                            <span class="ms-auto badge amount rounded-pill text-bg-primary">
                                {{ this.count }}
                            </span>
                        </button>
                    </div>
                </div>

                <div id="handoversTodo" class="accordion-collapse collapse" data-bs-parent="#todos">
                    <div class="accordion-body">
                        <div v-for="item in this.deliveryPoints" class="todo">
                            <div class="todo-data">
                                <div class="col-200">
                                    <p class="mb-0">
                                      {{ item.dossier_nr }} - {{ item.name }}
                                    </p>
                                </div>
                                <div class="date">
                                    <p class="mb-0">
                                        <i class="fa fa-calendar-o"></i>
                                        {{ item.date }}
                                    </p>
                                </div>
                            </div>
                            <div class="actions ms-auto">
                                <a :href="item.url" target="_blank">
                                    <i class="fa fa-external-link text-lightgrey"></i>
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>

export default {
    name: 'todos-delivery-point',
    components: {},
    props: {},
    data() {
        return {
            deliveryPoints: [{
                key: {
                    id: '',
                    dossier_nr: '',
                    name: '',
                    date: '',
                }
            }],
            count: 0,
            loading: true,
        }
    },
    computed: {},
    watch: {},
    methods: {
        getDeliveryPoints() {
            axios.get('api/todo-delivery-points')
                .then(response => {
                    this.deliveryPoints = response.data.deliveryPoints;
                    this.count = response.data.count;
                    this.loading = false;
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                });
        },

    },
    mounted() {
        this.getDeliveryPoints();
    },
    created() {},
}
</script>
